import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";

import DynamicIcon from "../../../../../../components/global/DynamicIcon";

/**
 * GeneratePatrimonioArquivoColumnDefinition
 */

type Props = {
  onActionEditar: (idItemchecklist: number | null, openState: boolean) => void;
  onActionDeletar: (idItemchecklist: number | null, openState: boolean) => void;
  onActionDownload: (idMaquinaEquipArquivo: number, imageName: string) => void;
};

export const GeneratePatrimonioArquivoColumnDefinition = ({
  onActionEditar,
  onActionDeletar,
  onActionDownload,
}: Props): GridColDef[] => {
  return [
    {
      field: "descricao",
      headerName: "Descrição",
      flex: 1,
      minWidth: 100,
      sortable: false,
      filterable: false,
      headerClassName: "projeto-header",
    },
    {
      field: "arquivo",
      filterable: false,
      headerName: "Arquivo",
      width: 175,
      sortable: false,
      resizable: false,
      valueGetter: (_, rows) => ({
        idMaquinaEquipArquivo: rows["idMaquinaEquipArquivo"],
        nome: rows["nome"],
      }),
      renderCell: (params) => {
        const maxSize = 20;
        const idMaquinaEquipArquivo = params.value["idMaquinaEquipArquivo"] as number;
        const nome = params.value["nome"] as string;

        return (
          <Button
            onMouseDown={() => onActionDownload(idMaquinaEquipArquivo, nome)}
            sx={{
              fontSize: 11,
              paddingX: ".4rem",
              paddingY: 0,
              background: "#e6e6e6",
              borderLeft: ".3rem solid #45b6af",
              borderRadius: 0,
              color: "black",
              fontWeight: "normal",
              width: "9.5rem",
            }}
          >
            {nome && nome.length > maxSize ? `${nome.substring(0, maxSize)}...` : nome}
          </Button>
        );
      },
    },
    {
      field: "idMaquinaEquipArquivo",
      headerName: "Ações",
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.row.idMaquinaEquipArquivo, true)}>
            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
          </IconButton>
          <IconButton onClick={() => onActionDeletar(params.row.idMaquinaEquipArquivo, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
  ];
};
